export const PIEVE_INTERACTION_SOURCE_DESKTOP = 'desktop';
export const PIEVE_INTERACTION_SOURCE_WEB = 'web';
export const PIEVE_DESKTOP_INTERACTION_ID_PREFIX = 'desktop:';

export const normalizePieveInteractionSource = (value) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  if (normalized === PIEVE_INTERACTION_SOURCE_DESKTOP || normalized === 'local') {
    return PIEVE_INTERACTION_SOURCE_DESKTOP;
  }

  if (normalized === PIEVE_INTERACTION_SOURCE_WEB || normalized === 'remote') {
    return PIEVE_INTERACTION_SOURCE_WEB;
  }

  return '';
};

export const resolvePieveInteractionSource = ({ interactionId = '', interactionSource = '' } = {}) => {
  const normalizedSource = normalizePieveInteractionSource(interactionSource);

  if (normalizedSource) {
    return normalizedSource;
  }

  const normalizedInteractionId = String(interactionId || '').trim();

  if (normalizedInteractionId.startsWith(PIEVE_DESKTOP_INTERACTION_ID_PREFIX)) {
    return PIEVE_INTERACTION_SOURCE_DESKTOP;
  }

  return PIEVE_INTERACTION_SOURCE_WEB;
};
